<!-- 研究方向 -->
<template>
  <div class="research-direction">
    <h1 class="application-title">研究方向</h1>
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate">
      <div class="research-direction-form">
        <div class="dis-30 label-bot-20">
          <FormItem label="1. Have you encountered any specific areas or topics of research that you find particularly exciting? How and why are those exciting to you?"
                    prop="interestedTask">
            <Input v-model="formValidate.interestedTask"
                   placeholder="Please limit your response to 500 words"
                   type="textarea"
                   :rows="15"></Input>
          </FormItem>
        </div>
        <div class="dis-30 label-bot-20">
          <FormItem label="2. Are there any specific research topics / issues that you want to pursue / help tackle?"
                    prop="captureTask">
            <Input v-model="formValidate.captureTask"
                   placeholder="Please limit your response to 500 words"
                   type="textarea"
                   :rows="15"></Input>
          </FormItem>
        </div>
        <div class="label-bot-20">
          <FormItem label="3. In the research labs you've worked for, have you previously met with students who were applying for graduate studies abroad? What were their application results?"
                    prop="xzxjqk">
            <Input v-model="formValidate.xzxjqk"
                   placeholder="Please limit your response to 500 words"
                   type="textarea"
                   :rows="15"></Input>
          </FormItem>
        </div>
        <div class="sub-btn" v-if="isallowedit">
          <Affix :offset-bottom="20">
            <Button type="primary"
                    style="width:96px;"
                    @click="saveHandle">保存</Button>
          </Affix>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import isAllowEdit from '@/view/mixins/is-edit'
//  api
import { infoModifyResearch, infoQueryDirection } from '@/api/info'
export default {
  name: 'application-research-direction',
  mixins: [isAllowEdit],
  components: {},
  data () {
    return {
      formValidate: {},
      ruleValidate: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      infoQueryDirection().then(res => {
        let data = res.data.model || {}

        this.formValidate = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    saveHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          infoModifyResearch(data).then(res => {
            this.$zlr_message('保存成功', 'success')
            this.$router.push({
              name: 'application-research-exp'
            })
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
